import { render, staticRenderFns } from "./TraineeDetails.vue?vue&type=template&id=6a1f58db&scoped=true"
import script from "./TraineeDetails.vue?vue&type=script&lang=js"
export * from "./TraineeDetails.vue?vue&type=script&lang=js"
import style0 from "./TraineeDetails.vue?vue&type=style&index=0&id=6a1f58db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1f58db",
  null
  
)

export default component.exports